import { render, staticRenderFns } from "./BtnDeleteResource.yaml?vue&type=template&id=0fe5176f&component"
import script from "./BtnDeleteResource.yaml?vue&type=script&lang=ts&component"
export * from "./BtnDeleteResource.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports